import React from 'react';

import SidebarItems from './SidebarItems/SidebarItems';
import SidebarProjectVersion from './SidebarProjectVersion';

const sidebar = ({auth}) => (
    <section className='main-sidebar'>
        <SidebarItems auth={auth}/>
        <SidebarProjectVersion />
    </section>
);

export default sidebar;
